<template>
    <base-drawer :open="open" :close="close" :title="title" @onClose="closeDrawer">
        <div v-if="insideProduct">
            <step-steps @updatePrice="calculeTemporaryPrice" @selectStepSize="selectStepSize" ref="stepStep" :product="insideProduct" :category="insideCategory" v-if="insideProduct.type == 'step'"/>
            <pizza-steps @updatePrice="calculeTemporaryPrice" ref="pizzaStep" :product="insideProduct" :category="insideCategory" v-else-if="insideProduct.type == 'pizza'"/>
            <simple-steps @updatePrice="calculeTemporaryPrice" ref="simpleStep" :product="insideProduct" :category="insideCategory" v-else-if="insideProduct.type == 'simple'" />
            <drink-steps @updatePrice="calculeTemporaryPrice" @selectStepSize="selectStepSize" ref="drinkStep" :product="insideProduct" :category="insideCategory" v-else-if="insideProduct.type == 'drink'" />
        </div>

        <template slot="footer">
            <div v-if="insideProduct" class="d-flex justify-between align-center">
                <base-button design="four" class="mr_5 big" @click="prevStep">
                    <span v-show="!prevText"><i class="fal fa-chevron-left"></i></span>
                    <span v-show="prevText"><i class="fal fa-times"></i></span>
                </base-button>

                <div class="subtotal">
                    <p class="text">subtotal</p>
                    <p class="value">{{ (+subtotal || 0).toFormat(StringLanguage.currencyConfigs) }}</p>
                </div>

                <base-button class="ml_5 big" @click="nextStep">
                    <span v-show="!nextText"><i class="fal fa-chevron-right"></i></span>
                    <span v-show="nextText"><i class="fal fa-check"></i></span>
                </base-button>
            </div>
        </template>
    </base-drawer>
</template>
<script>

import BaseDrawer from '@/components/Drawer'
import BaseButton from '@/components/Button'

import StepSteps from './SalesOrderSteps/Step'
import PizzaSteps from './SalesOrderSteps/Pizza'
import SimpleSteps from './SalesOrderSteps/Simple'
import DrinkSteps from './SalesOrderSteps/Drink'

import Builder from 'easyjs/lib/Schema/Components/Builder'

export default {
    components: {
        BaseDrawer,
        BaseButton,
        StepSteps,
        PizzaSteps,
        SimpleSteps,
        DrinkSteps
    },
    props: {
        open: Boolean,
        onClose: { type: Function },
        title: String,
        product: { type: Object },
        category: { type: Object }
    },
    data() {
        return {
            close: false,
            insideProduct: null,
            insideCategory: null,
            selectedStepSize: null,
            nextText: 'Próximo',
            prevText: 'Anterior',
            subtotal: 0
        }
    },
    mounted() {
        this.selectedStepSize = null;
        this.insideProduct = this.product ? Builder.mountSchema(JSON.parse(JSON.stringify(this.product))) : null;
        this.insideCategory = this.category ? Builder.mountSchema(JSON.parse(JSON.stringify(this.category))) : null;
        this.drawerTitle = this.category && this.product ? `${this.category.name} - ${this.product.name}` : '';
        this.$nextTick(() => {
            this.updateNextText();
            this.updatePrevText();
        })
    },
    updated() {
        this.updateNextText();
        this.updatePrevText();
    },
    watch: {
        product(newValue) {
            this.selectedStepSize = null;
            this.insideProduct = newValue ? Builder.mountSchema(Object.clone(newValue)) : null;
        },
        category(newValue) {
            this.insideCategory = newValue ? Builder.mountSchema(Object.clone(newValue)) : null;
        }
    },
    methods: {
        updateNextText() {
            if(this.product && !!this.$refs[`${this.product.type}Step`]) {
                let stepComponent = this.$refs[`${this.product.type}Step`].$refs.stepper
                // console.log(stepComponent.steps == stepComponent.current, stepComponent.steps, stepComponent.current)
                let newNextText = (stepComponent.steps == stepComponent.current) ? true : false;
                if(this.nextText != newNextText) {
                    this.nextText = newNextText
                    this.$forceUpdate()
                }
            }
        },
        updatePrevText() {
            if(this.product && !!this.$refs[`${this.product.type}Step`]) {
                let stepComponent = this.$refs[`${this.product.type}Step`].$refs.stepper
                let newPrevText = (stepComponent.current == 1) ? true : false;
                if(this.prevText != newPrevText) {
                    this.prevText = newPrevText
                    this.$forceUpdate()
                }
            }
        },
        closeDrawer() {
            this.subtotal = 0
            this.onClose()
            this.close = !this.close
        },
        cloneObject(obj) {
            return Builder.mountSchema(Object.clone(obj));
        },
        prevStep() {
            if(this.$refs[`${this.product.type}Step`]) {
                let stepComponent = this.$refs[`${this.product.type}Step`]
                if(stepComponent.$refs.stepper.current == 1) {
                    this.closeDrawer();
                    return false;
                }

                this.$refs[`${this.product.type}Step`].prev();
                this.updateNextText();
                this.updatePrevText();
            }
        },
        nextStep() {
            if(this.$refs[`${this.product.type}Step`]) {
                let stepComponent = this.$refs[`${this.product.type}Step`]
                if(stepComponent.$refs.stepper.current == stepComponent.$refs.stepper.steps) {
                    let product = this.cloneObject(this.insideProduct);
                    let tmpCatalog = Builder.factory('Catalog');
                    tmpCatalog.addItems(product);
                    Builder.executeOnSchema(tmpCatalog, (item) => {
                        for(let prop of ['items', 'extra_ingredients', 'doughs', 'edges']) {
                            if(Object.chain(item, prop, 'length')) {
                                for(let i = 0; i < item[prop].length; i++) {
                                    if(!item[prop][i].quantity || item[prop][i].quantity == 0 || item[prop][i].quantity == 'false') {
                                        item[prop][i] = null;
                                    } else {
                                        item[prop][i].quantity = item[prop][i].quantity == 'true' ? 1 : +item[prop][i].quantity
                                    }
                                }

                                item[prop] = item[prop].filter(i => i !== null);
                            }
                        }
                    });

                    if(this.selectedStepSize){
                        product.sizes = this.selectedStepSize;
                    }

                    this.$emit('addCart', product);
                } else {
                    stepComponent.next();
                    this.updateNextText();
                    this.updatePrevText();
                }
            }
        },
        selectStepSize(size){
            //Função para setar o size do produto do tipo Step ou Drink
            this.selectedStepSize = size;
        },
        calculeTemporaryPrice (obj) {
            this.subtotal = +obj.getPrice();
            return;

            if (obj && obj.type) {
                this.subtotal = 0

                this.subtotal += obj.price ? parseFloat(obj.price) : 0

                for (let i in obj) {
                    this.calculeTemporaryPrice(obj[i])
                }
            } else {
                if (typeof obj == 'object' || typeof obj == 'array') {
                    if (obj) {
                        let sumFlavors = 0
                        let qtyFlavors = 0
                        obj.forEach(item => {
                            if (item.quantity > 0) {
                                if (item.type == 'flavor') {
                                    sumFlavors += parseFloat(item.price)
                                    qtyFlavors += 1
                                } else if (item.type == 'question') {
                                    this.calculeTemporaryPrice(item.items)
                                } else {
                                    this.subtotal += parseFloat(item.price)
                                }
                            }
                        })
                        if (qtyFlavors >0) {
                            this.subtotal += sumFlavors/qtyFlavors
                        }
                    }
                }
            }
        }
    }
}
</script>
<style scoped>
    .subtotal{
        text-align: center;
    }
    .subtotal .text{
        font-size: 1.2em;
        margin-bottom: 5px;
        color: #AAAAAB;
        text-transform: uppercase;
        padding-left: 15px;
        padding-right: 15px;
    }
    .subtotal .value{
        color: #CCCCCC;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 15px;
        padding-right: 15px;
        font-size: 1.6em;
        font-weight: bold;
    }
</style>